// extracted by mini-css-extract-plugin
export default {"printable":"printer_printable__nQvtD","non_printable":"printer_non_printable__5NYeu"};